<div>
  <h4>Don't have an account?</h4>
  <p>
    <a [href]="moduleConfig?.UrlCreateAccount">Create your account now</a>
    @if (bestOfferProduct()?.PricePerMinute && bestOfferProduct()?.OfferId) { to <strong>redeem our special offer:</strong>}
  </p>
  @if (isProductBundleSession(bestOfferProduct())) {
  @if (bestOfferProduct()?.OfferDiscountAmount?.Amount > 0) {<!--Discount-->
  <p>
    <strong>{{bestOfferProduct()?.OfferDiscountAmount?.AmountFormatted}} off</strong> your first {{resources?.reading}}@if(expert()){<strong> with {{expert()?.Nickname}}</strong>}
  </p>
  }
  <p>
    {{(moduleConfig?.ExpertTariffsSupported && !expert())?'From ':''}}<strong>{{bestOfferProduct()?.Price?.AmountFormatted}}</strong> for {{bestOfferProduct()?.Minutes}} minutes (only <strong>{{bestOfferProduct()?.PricePerMinute?.AmountFormatted}}</strong>/min)
  </p>
  }
  @if (isProductPaygSession(bestOfferProduct())) {
  @if (bestOfferProduct()?.OfferBonusAmount?.Amount > 0) {<!--Bonus-->
  <p>
    <strong>{{bestOfferProduct()?.OfferBonusAmount?.AmountFormatted}} off</strong> your first {{resources?.reading}}@if(expert()){<strong> with {{expert()?.Nickname}}</strong>}
  </p>
  }
  @else if (bestOfferProduct()?.OfferDiscountAmount?.Amount > 0) {<!--Discount-->
  <p>
    <strong>{{bestOfferProduct()?.OfferDiscountAmount?.AmountFormatted}} off</strong> your first {{resources?.reading}}@if(expert()){<strong> with {{expert()?.Nickname}}</strong>}
  </p>
  }
  <p>
    <strong>{{bestOfferProduct()?.Price?.AmountFormatted}}</strong> for {{bestOfferProduct()?.OfferAmountCredited?.AmountFormatted ?? bestOfferProduct()?.Price?.AmountFormatted}} credit ({{(moduleConfig?.ExpertTariffsSupported && !expert())?'from ':''}}only <strong>{{bestOfferProduct()?.PricePerMinute?.AmountFormatted}}</strong>/min)
  </p>
  }
  @if (isProductGeneralTopUp(bestOfferProduct())) {
  <p>
    Buy {{bestOfferProduct()?.Price?.AmountFormatted}} @if ((bestOfferProduct()?.OfferBonusAmount?.Amount ?? 0) > 0) {
    get <strong>{{bestOfferProduct()?.OfferBonusAmount?.AmountFormatted}} free</strong> on your first {{resources?.reading}}@if(expert()){<strong> with {{expert()?.Nickname}}</strong>}
    } @else {
    Credit
    } (only <strong>{{bestOfferProduct()?.PricePerMinute?.AmountFormatted}}</strong>/min)
  </p>
  }
  @if (isProductMinutesTopUp(bestOfferProduct())) {
  <p>{{bestOfferProduct()?.Price?.AmountFormatted}} for {{bestOfferProduct()?.Minutes}} minutes (only <strong>{{bestOfferProduct()?.PricePerMinute?.AmountFormatted}}</strong>/min)</p>
  }
</div>
